import registerPerformanceObserver from '../register-performance-observer';

const RECORD_TYPE = 'first-input';

/**
 * Track first input delay. (https://web.dev/fid/)
 * This is the delay between page initialization and the user's first interaction.
 */
const firstInputDelayObserver = (
  callback: (firstInputDelay: number) => void
) => {
  return registerPerformanceObserver(RECORD_TYPE, list => {
    for (const entry of list.getEntries()) {
      // @ts-ignore for `entry.processingStart`
      callback(entry.processingStart - entry.startTime);
    }
  });
};

export default firstInputDelayObserver;
